import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createProjectLabel: {
		id: 'spa-apps-sidebar-core.multi-project-menu.projects-header.create-project-button.create-project-label',
		defaultMessage: 'Create project',
		description: 'Label for the create project button.',
	},
});
